
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import { form4StatusInfoType } from '@/types/Information/Form4';

@Component({
    components:{
        Form4ProcessHeader
    }
})
export default class ErrorSubmitForm4 extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;

    stepsCompleted = {} as form4StatusInfoType;  
    mountedData = false;     

    mounted() {
        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            thirdError:true
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
